export default function selectButton(e,selectedClass,callback){
    let targetElement = e.target;
    let targetGroup = $(targetElement).attr("group");
    let targetParent = $(targetElement).parent();

    let groupElements = $(targetParent).find("div[group='"+targetGroup+"']");

    $(groupElements).removeClass(selectedClass);
    $(targetElement).addClass(selectedClass);
    
    if(typeof(callback)==="function"){
      callback();
    }
}
